



































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator';
import { NavBar, Popup, Toast, Progress, Loading } from 'vant';
import navbar from '@/components/navBar.vue';
import { getBookList } from '../../API/booklist';
import { Getter, Mutation } from 'vuex-class';

@Component({
    name: 'booklist',
    components: {
        [NavBar.name]: NavBar,
        [Popup.name]: Popup,
        [Progress.name]: Progress,
        [Loading.name]: Loading,
    },
    filters: {
        formatDuration(duration: number): string {
            if (duration) {
                let min = Math.floor(duration / 60);
                let second = duration % 60;
                return (min < 10 ? '0' + min : min) + ':' + (second < 10 ? '0' + second : second);
            }
            return '00:00';
        }
    }
})

export default class App extends Vue {

    private showNavBar:boolean = false;
    private type: any = '';
    private typeList: any = [
        '听力训练',
        '心理健康',
        '英语书写',
    ]
    private bookList: Array<string> = []; // 书本资源
    private defaultImg = require('@/assets/img/booklist/img_default.png');
    private readImg = require('@/assets/img/booklist/img_read.png');
    
    created() {
        console.log("created...");
        document.title = "";
        this.type = this.$route.query.type ? this.$route.query.type : '1';
    }

    mounted() {
        console.log("mounted......book list.");
        let index = Number(this.type)
        document.title = this.typeList[index - 1];
        this.$nextTick(() =>{
            this.getBookList();
        });
    }

    @Watch('$route')
    routechange(to: any, from: any) {
        let index = Number(this.type);
        document.title = this.typeList[index - 1];
        if ((from.name == 'Home' || from.name == 'mentalhealth') &&  to.name == 'booklist') {
            this.getBookList();
        }
    }

    private onClickLeft(): void {
        this.$router.go(-1);
    }

    private onClickOpenBook(itemObj:any): void {
        console.log("on click open...");
        console.log(itemObj);
        let index = Number(this.type);
        let urlList = [
            '/Home',
            '/mentalhealth',
            '/writingBook'
        ]
        if (itemObj && itemObj.id) {
            this.$router.push({ path: urlList[index-1], query: {'bookId': itemObj.id , 'bBack': '1'}});
        }
    }

    private getBookList(): void {
        var self = this;
        this.bookList = [];
        const params = {
            type: '' + this.type,
        }
        console.log("book list>>>");
        getBookList(params).then((res: any) => {
            console.log("get book list:::::::::::::::res:", res);
            if (res && res.success) {
                var obj = res.obj;
                obj.forEach((v:any, i:any) =>{
                    var name = v.name;
                    var length = name.replace(/[^\x00-\xff]/g,"xx").length;
                    v.nameSize = Math.floor(length/20) + 1;
                });
                for (var i=1; i<obj.length; ++i) {
                    if (obj[i-1].nameSize >= obj[i].nameSize) {obj[i].nameSize = obj[i-1].nameSize;} else {obj[i-1].nameSize = obj[i].nameSize;}
                    i += 1;
                }
                self.bookList = res.obj;
            }
        }).catch((err) => {
            console.log(err, 'err')
            Toast('网络开了小差~');
        })
    }
}

